<template>
    <div class="main-orderlist">
        <div class="list-wrapper" v-if="filtedOrder.length !== 0">
            <OrderItem
                v-for="(order, k) in filtedOrder"
                :key="k"
                :index="k"
                :order="order"
                @clickOrder="clickOrder($event)"
            />
        </div>
        <div class="no-order" v-else>ไม่มีคำสั่งซื้อในวันนี้</div>
        <b-modal
            id="modalOrder"
            centered
            hide-header
            hide-footer
            no-close-on-backdrop
            no-close-on-esc
        >
            <div class="order-main" v-if="Object.keys(clickedModal).length > 0">
                <div class="close-btn" @click="$bvModal.hide('modalOrder')">
                    <img src="@/assets/profile/close-new.svg" alt="" />
                </div>
                <div class="order-header">
                    <div class="title-scc">
                        <h2>เมนูสำหรับวันนี้</h2>
                        <div class="order-id">
                            เลขออเดอร์ : {{ clickedModal.TranId }}
                        </div>
                    </div>
                    <div class="detail-scc">
                        <div class="detail-container">
                            <div class="detail-icon">
                                <img
                                    src="@/assets/campaignlist/white_location.svg"
                                    alt=""
                                />
                            </div>
                            <div class="detail-text">
                                <p>สาขา</p>
                                <div>
                                    {{ clickedModal.DeliveryFromJson.Name }}
                                </div>
                            </div>
                        </div>
                        <div class="white-line"></div>
                        <div class="detail-container">
                            <div class="detail-icon">
                                <img
                                    src="@/assets/campaignlist/white_calendar.svg"
                                    alt=""
                                />
                            </div>
                            <div class="detail-text">
                                <p>รับเวลา</p>
                                <div>{{ clickedModal.dateForm }}</div>
                            </div>
                        </div>
                    </div>
                    <div class="order-scc">
                        <div class="order-header">เมนู</div>
                        <ul class="order-list">
                            <li
                                v-for="(item, index) in clickedModal
                                    .OrderDetail[0].Item"
                                :key="index"
                                class="order-item"
                            >
                                <div class="image-container">
                                    <img :src="item.FullImageUrl" alt="" />
                                </div>
                                <div class="desc-container">
                                    <div class="desc-name">
                                        <div class="quantity">
                                            {{ item.Quantity }}x
                                        </div>
                                        <div class="name">{{ item.Name }}</div>
                                    </div>
                                    <div
                                        v-for="(extra, index) in item.Side"
                                        :key="index"
                                        class="desc-amount"
                                    >
                                        <div class="quantity">
                                            {{ extra.Quantity }}x
                                        </div>
                                        <div class="name">{{ extra.Name }}</div>
                                    </div>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
                <div
                    v-if="
                        clickedModal.cancelable &&
                        activetab === 'สั่งสำเร็จ-รับที่ร้าน'
                    "
                    class="underline-btn"
                    @click="handleClickCancel(clickedModal.TranId)"
                >
                    ยกเลิกรายการวันนี้
                </div>
                <!-- <div v-else class="brown-btn disable">
                    ยกเลิก
                </div> -->
                <!-- <div class="underline-btn" @click="$router.push('/changeplan/' + clickedModal.date)">
                    See other plan of Cancel subscription
                </div> -->
            </div>
        </b-modal>
        <ModalMaster :controller="modalController"></ModalMaster>
    </div>
</template>

<script>
// import moment from "moment";
import Mixin from "@/mixin/Mixin";
//helper
import Account from "@/helper/AccountHelper.js";
//mixin
import ModalMixin from "@/mixin/ModalMixin.js";
//component
import OrderItem from "@/module/Order/component/OrderItem.vue";
//service
import BzbsShoppingCart from "@/core/Cart/service/BzbsCart.js";

export default {
    name: "OrderList",
    components: {
        OrderItem,
    },
    props: {
        activetab: String,
    },
    mixins: [Mixin, ModalMixin],
    data() {
        return {
            orderList: [],
            completeList: [],
            cancelList: [],
            filtedOrder: [],
            clickedModal: {},
            token: Account.getToken(),
            type: "pickup",
        };
    },
    mounted() {
        this.handleLoading(true);
        Promise.all([
            this.getOrder(),
            this.getCompleteOrder(),
            this.getCancelOrder(),
        ]).then(() => {
            this.filterOrder(this.activetab);
            this.handleLoading(false);
        });
    },
    watch: {
        activetab() {
            return this.filterOrder(this.activetab);
        },
    },
    methods: {
        getOrder() {
            return new Promise((resolve, reject) => {
                BzbsShoppingCart.apiGetShoppingOrder(
                    this.token,
                    this.type
                ).subscribe(
                    (order) => {
                        this.orderList.push(...order);
                        resolve(this.orderList);
                    },
                    (err) => {
                        reject(err);
                    }
                );
            });
        },
        getCompleteOrder() {
            return new Promise((resolve, reject) => {
                BzbsShoppingCart.apiGetCompletedOrder(
                    this.token,
                    this.type
                ).subscribe(
                    (order) => {
                        this.completeList.push(...order);
                        resolve(this.completeList);
                    },
                    (err) => {
                        reject(err);
                    }
                );
            });
        },
        getCancelOrder() {
            return new Promise((resolve, reject) => {
                BzbsShoppingCart.apiGetCancelOrder(this.token).subscribe(
                    (order) => {
                        this.cancelList.push(...order);
                        resolve(this.completeList);
                    },
                    (err) => {
                        reject(err);
                    }
                );
            });
        },
        clickOrder(item) {
            this.clickedModal = item;
            this.$bvModal.show("modalOrder");
        },
        filterOrder(tab) {
            this.filtedOrder = [];
            if (tab === "ยกเลิก-คืนเงิน") {
                this.filtedOrder = this.cancelList;
            } else if (tab === "สั่งสำเร็จ-รับที่ร้าน") {
                this.filtedOrder = this.orderList;
            } else {
                this.filtedOrder = this.completeList;
            }
            if (this.filtedOrder) {
                this.isHaveItem = true;
            }
        },
        handleClickCancel(TranId) {
            this.confirmModal.setData({
                title: "Cancel today's coffee",
                msg: "คุณต้องการยกเลิกรายการวันนี้หรือไม่ ?",
                btnOk: "ยืนยัน",
                btnCancel: "ไม่ต้องการ",
                hideClose: true,
                userCallback: true,
                buttonStyle: true,
            });
            this.confirmModal.onClickOk(() => {
                this.cancelOrder(TranId);
            });
            this.confirmModal.show({ params: null });
        },
        cancelOrder(TranId) {
            return new Promise((resolve, reject) => {
                BzbsShoppingCart.apiCancelOrder(this.token, TranId).subscribe(
                    (res) => {
                        resolve(res);
                        window.location.reload();
                    },
                    (err) => {
                        reject(err);
                        window.location.reload();
                    }
                );
            });
        },
    },
};
</script>

<style lang="scss" scoped>
@import "@/module/Order/style/orderStyle.scss";
.main-orderlist {
    .white {
        font-size: 12px;
        color: #fff;
        span {
            color: red;
        }
    }
    .no-order {
        height: 70vh;
        display: flex;
        align-items: center;
        justify-content: center;
    }
}
</style>
